import React, { Component } from 'react'
import Chevron from '../../assets/image/chevron-right.svg'
import './style.css'
import {withRouter} from 'react-router-dom';
class index extends Component {
    renderBread=()=>{
        let title=this.props.data.map((data,i)=>{
            return data.title
        }).join(' > ')
        // console.log('title',title)
        return title
    }
    renderAction=()=>{
        const {data}=this.props
        if(data[1]===''){
            return null
        }else{
            this.props.history.goBack();
        }
    }
    render() {
        const {data}=this.props
        console.log('data', data)
        return (
            <div>
                <div className='breadcrum'>
                    <p style={{color:data[1].length>0?'#00a1ed':'#464646'}} onClick={()=>this.renderAction()}>{data[0]}</p>
                    {data[1].length>0&&
                    <>
                    &nbsp;
                    <img src={Chevron} style={{width:5}}/>
                    &nbsp;
                    <p>{data[1]}</p>
                    </>
                    }
                    {/* {data.map((data,i)=>(<p>{data.title}</p>)).join('3 ')} */}
                    {/* {this.renderBread()} */}
                </div>
            </div>
        )
    }
}
export default withRouter(index)